export enum FixationFrequency {
  DAILY = 'DAILY',
  IF_REQUIRED = 'IF_REQUIRED',
}

export enum TubeApplicationType {
  INDEPENDENT = 'INDEPENDENT',
  UNINDEPENDENT = 'UNINDEPENDENT',
  COMPLETELY_UNINDEPENDENT = 'COMPLETELY_UNINDEPENDENT',
}

export enum WeightControlDecisionType {
  RESIDENT = 'RESIDENT',
  NURSE = 'NURSE',
}

export enum ConsciousnessState {
  AWAKE = 'AWAKE',
  DROWSY = 'DROWSY',
  SOMNOLENT = 'SOMNOLENT',
  SOPOROSE = 'SOPOROSE',
  COMATOSE = 'COMATOSE',
  VEGETATIVE = 'VEGETATIVE',
}
